import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./Games.scss";
import { PAGE_SIZE } from "../../../constants";
import { Link } from "react-router-dom";
import SpinTheWheelGameMessagesTable from "../../Tables/SpinTheWheelGameMessages";
import {
	createSpinGameMessage,
	deleteSpinGameMessage,
	fetchSpinGameMessages,
	resetDeleteStatusSpinGameMessage,
	updateSpinGameMessage,
} from "../../../actions/spinTheWheelGameMessage";
import { ReactSVG } from "react-svg";
import SpinGameMessgeForm from "../../Forms/SpinTheWheelGameMessage";

const SpinTheWheelGameMessagesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { spinGameMessages, loading } = useSelector(
		(state) => state.fetchSpinGameMessages,
	);
	const { spinGameMessageDeleted } = useSelector(
		(state) => state.deleteSpinGameMessage,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSpinGameMessage,
	);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({});
	const [spinGameMessageId, setSpinGameMessageId] = useState(null);
	const limit = Number(PAGE_SIZE) || 20;
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameMessageId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameMessageId(null);
	};

	const handleEdit = (record) => {
		showModal();
		setSpinGameMessageId(record.id);
		console.log("record ", record);
		form.setFieldsValue({
			...record,
		});
	};

	const handleClickDelete = (record) => {
		dispatch(deleteSpinGameMessage(record.id));
	};

	const addNewGameMessageClick = () => {
		showModal();
		form.resetFields();
	};

	const handleSubmitForm = (values) => {
		if (spinGameMessageId) {
			dispatch(updateSpinGameMessage(spinGameMessageId, values));
		} else {
			dispatch(createSpinGameMessage(values));
		}
		handleOk();
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(
			fetchSpinGameMessages({ start: Number(startAt), count: PAGE_SIZE }),
		);
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		if (spinGameMessageDeleted) {
			dispatch(fetchSpinGameMessages({ start: 0, count: PAGE_SIZE }));
			dispatch(resetDeleteStatusSpinGameMessage());
		}
	}, [spinGameMessageDeleted]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchSpinGameMessages({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (spinGameMessages) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: spinGameMessages.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [spinGameMessages]);

	useEffect(() => {
		dispatch(fetchSpinGameMessages({ start: 0, count: PAGE_SIZE }));
	}, []);

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Dropdown.Button overlay={() => tableActionMenu(record)} />
			</span>
		);
	};

	const tableActionMenu = (record) => (
		<Menu className="table-action-menu">
			<Menu.Item key="view">
				<Link to={`/spin-the-wheel/game-messages/${record?.id}`}>
					<Button className="btn-table-action-primary" type="link">
						Show
					</Button>
				</Link>
			</Menu.Item>
			<Menu.Item key="edit">
				<Button
					className="btn-table-action-primary"
					type="link"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</Menu.Item>
			<Menu.Item key="delete">
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</Menu.Item>
		</Menu>
	);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-game-messages-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Game Messages</li>
						</ul>
					</div>
					<div>
						<Button
							type="primary"
							className="btn btn-primary"
							onClick={addNewGameMessageClick}
						>
							New Game Message
							<ReactSVG src="/icons/post-add.svg" />
						</Button>
					</div>
				</div>
				<div className="page-content">
					{spinGameMessages && (
						<SpinTheWheelGameMessagesTable
							rowKey="id"
							dataSource={spinGameMessages.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={50}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="spin-form-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{spinGameMessages && (
						<SpinGameMessgeForm
							form={form}
							spinGameMessageId={spinGameMessageId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default SpinTheWheelGameMessagesPage;
